import React from 'react'

import {InputContainer} from './TelephoneNumber.styled'

import {Input} from '~/components/general/input/Input'

type TelephoneNumberProps = {
  className?: string
  disabled?: boolean
  errorMessage?: string
  size?: 'large' | 'normal' | 'small'
  placeholder?: string
  value?: string
  onChange: (value: string) => void
  onBlur?: React.FocusEventHandler<HTMLInputElement>
  onFocus?: React.FocusEventHandler<HTMLInputElement>
  required?: boolean
}

export const TelephoneNumber: React.FC<TelephoneNumberProps> = ({
  className,
  disabled,
  size = 'normal',
  errorMessage,
  placeholder,
  value,
  onChange,
  onBlur,
  onFocus,
  required,
}) => (
  <InputContainer className={className}>
    <Input
      type="tel"
      size={size}
      disabled={disabled}
      placeholder={placeholder}
      value={value}
      onChange={(event) => onChange(event.target.value)}
      onBlur={onBlur}
      onFocus={onFocus}
      required={required}
      errorMessage={errorMessage}
    />
  </InputContainer>
)
